import moment from 'moment-timezone';
import { getXAxisLabelFormat, TOOLTIP_LABEL_FORMAT } from '@components/common/Charts/utils';
import { humanize } from '@utils';
import { FONT_FAMILY } from '@utils/constants';
import { getMetricUnitText, getMetricUnit, getMetricOvbDisplayName } from '@utils/metrics';
import { query as originQuery } from './schema';

const createQuery = (metricName, interval, filter, granularity, kpiConfig) => {
  const query = {
    ...originQuery,
    interval,
    filter,
    granularity,
    metrics: [metricName],
  };

  query.options.kpiConfig = kpiConfig;

  return {
    queries: [query],
  };
};

const formatMetricDataForChart = (data, metric, color) => {
  const chartData: any = data.map((eachItem) => [eachItem.timestamp, eachItem.results[metric]]);

  const xAxisFormatter = (value) => {
    const length = data.length;
    const diff =
      length > 1 ? moment(data[length - 1].timestamp).diff(moment(data[0].timestamp)) : 0;
    const format = getXAxisLabelFormat(diff);
    return moment(value).format(format);
  };

  const yAxisFormatter = (value) => {
    const unit = getMetricUnit({ metricKey: metric });
    const yVal = humanize(value, unit);
    return `${yVal}${unit}`;
  };

  const tooltipFormatter = (params) => {
    const unit = getMetricUnit({ metricKey: metric });
    const value = params[0].data;
    const yVal = humanize(value[1], unit);
    const metricDisplayName = getMetricOvbDisplayName({ metricKey: metric });
    const xVal = moment(value[0]).format(TOOLTIP_LABEL_FORMAT);
    return `${xVal}<br/>${metricDisplayName} - <b>${yVal}${getMetricUnitText(unit)}</b>`;
  };

  const option: any = {
    color: [color],
    grid: {
      left: 40,
      bottom: 5,
      right: 20,
      top: 20,
    },
    tooltip: {
      trigger: 'axis',
      formatter: tooltipFormatter,
    },
    xAxis: {
      type: 'time',
      splitNumber: 6,
      axisLabel: {
        color: 'black',
        fontSize: '8px',
        formatter: xAxisFormatter,
        fontFamily: FONT_FAMILY,
        show: false,
      },
      splitLine: {
        show: false,
      },
      axisLine: {
        show: false,
        lineStyle: {
          color: '#CCCCCC',
        },
      },
      axisTick: {
        show: false,
      },
    },
    yAxis: {
      type: 'value',
      splitNumber: 2,
      splitLine: {
        lineStyle: {
          color: '#e5e5e5a3',
        },
      },
      axisLabel: {
        formatter: yAxisFormatter,
        showMinLabel: false,
        color: '#333',
        fontSize: 12,
      },
      axisTick: {
        show: false,
      },
      axisLine: {
        show: false,
      },
    },
    series: [
      {
        data: chartData,
        type: 'line',
        showSymbol: false,
        areaStyle: {
          opacity: 0.2,
        },
        lineStyle: {
          width: 1,
        },
      },
    ],
  };
  return option;
};

export { createQuery, formatMetricDataForChart };
